import Swiper from 'swiper/bundle';
export default {
  init() {

    // JavaScript to be fired on all pages, after page specific JS is fired

    var swiperOptions = {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 0,
     /* freeMode: false,
      freeModeMomentum: false,
      freeModeMomentumRatio: 1,
      freeModeMomentumVelocityRatio: 1,
      freeModeMomentumBounce: false, 
      freeModeMomentumBounceRatio: 0,
      freeModeMinimumVelocity: 0.5,
      freeModeSticky: true,*/
      loop: true,
      loopedSlides: 3,
      speed: 12000,
      grabCursor: true,
      autoplay: { delay: 0 },
      touchRatio: 3,

      /*pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },*/
};

var swiper = new Swiper('.swiper-container-product', swiperOptions);
swiper

var timeout_swiper;
swiper.on('touchStart', function(){
  console.log('start');  
  swiper.autoplay.stop();
  clearTimeout(timeout_swiper);

})
swiper.on('touchEnd', function(){
  console.log('end');
 
  timeout_swiper =  setTimeout(function(){
    swiper.autoplay.stop();
    swiper.autoplay.start();
    console.log('riparti');
  },1500);
  
})
   /* $('.owl-carousel-test').owlCarousel({
      
      loop: true,
      autoplay: false,
      autoplaySpeed: 2000,      
      dots: true,      
      items: 1,  
      autoWidth: true,
      smartSpeed: 2000,
      nav: true,
      slideBy: 1,
      responsive: false,
     });*/

 /*   const test = new Swiper('.swiper-container',{
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
      freeModeMomentum: true,
      freeModeMomentumRatio: 2,
      freeModeMomentumVelocityRatio: 0.5,
      freeModeSticky: false,
      loop: true,
      loopedSlides: 3,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
    test*/
  
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleproduct.js